import React, { useState, useEffect } from "react";
import { Radio, Form, DatePicker } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { SLOTS, PROVIDERLIST } from "../../../core-units/constants/actionTypes";
import agent from "../../../agent";
import "../ev-home-page.css";
import _ from "lodash";

const dateFormat = "YYYY-MM-DD";

const StepAppointment = (props) => {
  const dispatch = useDispatch();
  const { schedule, provider } = useSelector((state) => state.services);

  const [evService, setEvService] = useState({});
  const [evProduct, setEvProduct] = useState({});
  const [evCoupon, setEvCoupon] = useState({});
  const [evTotal, setEvTotal] = useState(0);
  const [evProviderId, setEvProviderId] = useState(1);
  const [evDate, setEvDate] = useState(
    localStorage.getItem("evDate")
      ? dayjs(localStorage.getItem("evDate"))
      : dayjs().format(dateFormat),
  );
  const [evTime, setEvTime] = useState(dayjs().format("HH:mm:ss"));
  const [evCurrentDate, setevCurrentDate] = useState(new Date());
  const [evTimePro, setEvTimePro] = useState([]);
  const [evProviderSlotsMap, setEvProviderSlotsMap] = useState({});
  const [evSelectedProviderId, setEvSelectedProviderId] = useState(null);

  // useEffect(() => {
  //   getTimeSlots(dayjs(date, dateFormat).format(dateFormat));

  //   const retrieveService = localStorage.getItem('service');
  //   const retreveProduct = localStorage.getItem('product');

  //   setDate(
  //     localStorage.getItem('date')
  //       ? dayjs(localStorage.getItem('date'))
  //       : dayjs().format(dateFormat)
  //   );
  //   setService(!_.isEmpty(retrieveService) ? JSON.parse(retrieveService) : {});
  //   setProduct(!_.isEmpty(retreveProduct) ? JSON.parse(retreveProduct) : {});
  //   setCoupon(localStorage.getItem('couponData'));
  //   setTotal(localStorage.getItem('total'));
  //   setTime(localStorage.getItem('time'));
  // }, []);

  useEffect(() => {
    const retrieveService = localStorage.getItem("evService");
    const retrieveProduct = localStorage.getItem("evProduct");

    const parsedService = retrieveService ? JSON.parse(retrieveService) : {};
    const parsedProduct = retrieveProduct ? JSON.parse(retrieveProduct) : {};

    setEvService(parsedService);
    setEvProduct(parsedProduct);
    setEvCoupon(localStorage.getItem("evCouponData"));
    setEvTotal(localStorage.getItem("evTotal"));
    setEvTime(localStorage.getItem("evTime"));
    setEvDate(
      localStorage.getItem("evDate")
        ? dayjs(localStorage.getItem("evDate"))
        : dayjs().format(dateFormat),
    );
  }, []);

  useEffect(() => {
    if (evService && evService.id) {
      getTimeSlots(dayjs(evDate, dateFormat).format(dateFormat));
    }
  }, [evService, evDate]);

  const disabledDate = (current) => {
    return current && current < dayjs().endOf("day");
  };

  const onChange = (date, dateString) => {
    if (dateString) {
      getTimeSlots(dateString);
    }
    setEvDate(date);
    localStorage.setItem("evDate", dateString);
  };

  const getTimeSlots = (date) => {
    const providerSlotsMap = {};
    dispatch({
      type: PROVIDERLIST,
      payload: agent.Services.provider_list(""),
      callback: (value) => {
        _.map(_.get(value, "data"), (each) => {
          let requestParams = {
            service_id: evService.id,
            date: date,
            provider_id: _.get(each, "id"),
          };
          dispatch({
            type: SLOTS,
            payload: agent.Services.schedule(requestParams),
            callback: (valu) => {
              providerSlotsMap[_.get(each, "id")] = valu;
              const array = Object.values(providerSlotsMap).flat();
              const uniqueData = [...new Set(array)];
              const removeDuplicates = (data, key) => {
                return [
                  ...new Map(data.map((item) => [key(item), item])).values(),
                ];
              };
              uniqueData.sort((a, b) => {
                return dayjs(a.time, "HH:mm") - dayjs(b.time, "HH:mm");
              });
              setEvTimePro(removeDuplicates(uniqueData, (item) => item.time));
              setEvProviderSlotsMap(providerSlotsMap);
            },
          });
        });

        const ids = _.chain(_.get(value, "data")).map("id").value();
        setEvProviderId(ids);
        localStorage.setItem("evProviderId", ids);
      },
    });
  };

  const onTimeChange = (e) => {
    props.AppvalidationHandler();
    const selectedTime = e.target.value;

    let selectedProviderId = null;
    for (const providerId in evProviderSlotsMap) {
      const slots = evProviderSlotsMap[providerId];
      if (slots.some((slot) => slot.time === selectedTime)) {
        selectedProviderId = providerId;
        break;
      }
    }

    setEvTime(selectedTime);
    setEvSelectedProviderId(selectedProviderId);
    localStorage.setItem("evTime", selectedTime);
    if (selectedProviderId) {
      localStorage.setItem("selectedEvProviderId", selectedProviderId);
    }
  };

  const timeSlots = () => {
    const slots = evTimePro ? evTimePro : schedule;
    if (!_.isEmpty(slots)) {
      return (
        <Radio.Group
          defaultValue={evTime}
          onChange={onTimeChange}
          buttonStyle="solid"
        >
          {_.map(slots, (val, key) => {
            if (_.get(val, "time")) {
              return (
                <Radio.Button value={val.time} key={key}>
                  {dayjs(_.get(val, "time"), "HH:mm").format("h.mm A")}
                </Radio.Button>
              );
            }
          })}
        </Radio.Group>
      );
    } else if (!_.isEmpty(evTime)) {
      return (
        <Radio.Button value={dayjs(evTime, "HH:mm").format("h.mm A")} key={evTime}>
          {dayjs(evTime, "HH:mm").format("h.mm A")}
        </Radio.Button>
      );
    } else {
      return <span>No slots Available</span>;
    }
  };

  return (
    <div className="EvInspectionStepsContainer">
      <div className="EvStepAppointmentInfo">
        <div className="EvPricingAddOnTitle">Book your Appointment</div>
        <div className="EvInspectionStepTitle">
          {_.get(evService, "name")} <b>$ {_.get(evService, "price")}</b>
          {_.map(evProduct, function (val, key) {
            return (
              <React.Fragment key={key}>
                + {_.get(val, "name")} <b>$ {_.get(val, "price")}</b>
              </React.Fragment>
            );
          })}
        </div>
        <div className="EvCouponCodeTotal">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-2">
              <div className="EvCouponCodeTotalSection">
                <span>Total</span>
                <span className="EvCouponCodeTotalAmount">$ {evTotal}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="EvStepsFormCardContainer">
          <div className="row justify-content-center">
            <div className="col-12 col-md-12 col-lg-6">
              <div className="EvStepsFormCard">
                <Form className="row">
                  <Form.Item
                    className="col-12 col-md-12 mb-2"
                    label="Select Date"
                  >
                    <DatePicker
                      disabledDate={disabledDate}
                      defaultValue={dayjs(evDate, dateFormat)}
                      format={dateFormat}
                      onChange={onChange}
                    />
                  </Form.Item>
                  <Form.Item
                    className="col-12 col-md-12 EvTimeRadioGroup"
                    label="Pick Time"
                  >
                    {timeSlots()}
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepAppointment;
